import { MiscRecordPage } from "./MiscRecordPage";
import { Handshake } from "@phosphor-icons/react";

export default function Quotation() {
  return (
    <MiscRecordPage
      variant="quotation"
      kicker="Sales"
      title="Quotation"
      subtitle="Quotations sent to customers. Attach any file type — PDF, Excel, Word, images, ZIP."
      testIdPrefix="quotation"
      Icon={Handshake}
    />
  );
}
